import { IconDownload as TablerIconDownload } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconDownload = /*#__PURE__*/ createOutlineIcon(TablerIconDownload, 'IconDownload');
